function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ChangeHighlightedImmutableUnderReviewFormCheck from '../reviewEditControls/ChangeHighlightedImmutableUnderReviewFormCheck';
import ChangeHighglightedImmutableUnderReviewDropdown from '../reviewEditControls/ChangeHighglightedImmutableUnderReviewDropdown';
export function ChangeHighlightedFormDropdownRow(_ref) {
  let {
    fieldName,
    label,
    checked,
    valuesArray,
    valueInstanceTextFieldName = 'name',
    labelColSpan = 3,
    valueColSpan = 3,
    onChange,
    onBlur,
    object,
    disabled = false,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: true,
    md: labelColSpan
  }, t(`${label || fieldName}`)), /*#__PURE__*/React.createElement(Col, {
    md: valueColSpan
  }, /*#__PURE__*/React.createElement(ChangeHighglightedImmutableUnderReviewDropdown, _extends({
    onChange: onChange,
    onBlur: onBlur,
    object: object,
    userUnauthorizedToEdit: disabled,
    disabled: disabled,
    edittedObjectFieldName: fieldName,
    edittedObject: object,
    valuesArray: valuesArray,
    valueInstanceTextFieldName: valueInstanceTextFieldName
  }, props))));
}